/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Credentials_Global_Toast_ErrorInputs */

const es_components_credentials_global_toast_error = /** @type {(inputs: Components_Credentials_Global_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo actualizar la visibilidad`)
};

const en_components_credentials_global_toast_error = /** @type {(inputs: Components_Credentials_Global_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update visibility`)
};

/**
* | output |
* | --- |
* | "Failed to update visibility" |
*
* @param {Components_Credentials_Global_Toast_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_credentials_global_toast_error = /** @type {((inputs?: Components_Credentials_Global_Toast_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Credentials_Global_Toast_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_credentials_global_toast_error(inputs)
	return en_components_credentials_global_toast_error(inputs)
});
export { components_credentials_global_toast_error as "components.credentials.global.toast.error" }